
import request from '../../utils/request';
import { stringify } from 'qs';

export async function getIdByCode(params) {
    return request(`/api/blade-system/app-attr-tmpl/getTempIdByCode?${stringify(params)}`);
}

export async function getAttrsByTmpId(params) {
    return request(`/api/blade-system/attribute-template-detail/getAttrTempInfoListByTmplId?${stringify(params)}`);
}
  
export async function getAttrList(params) {
    return request(`/api/blade-system/attribute-template-detail/getAttrListByAttrTmplDetailId?${stringify(params)}`);
}